import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ALERTS_PENDING_PAYMENT: MijnRoute = {
    path: 'ingepland-geweigerd-notificatie',
    navigationEvent: 'toIngeplandGeweigerdNotificaties',
    regex: /^\/zelf-regelen\/notificaties-beheren\/ingepland-geweigerd-notificatie$/,
    webcomponent: 'mijn-klant-notificatie-beheer-webcomponent',
    internalPath: '/ingepland-geweigerd-notificatie'
};
